import React from "react";
import { InlineMarkerButton } from "./InlineMarkerButton";

/**
 * 병원 가명 버튼 — 시각 규격 V2(spec 설계 결정 13). PrescriptionButton과 공통 기반
 * `InlineMarkerButton`(인라인 전용 styled button)을 공유한다. atoms/Button 미사용.
 *
 * - `onHospitalClick` 있으면 클릭 가능한 병원명 버튼(3단·팝업). 없으면 평문 <span>(인쇄·임베드) —
 *   밑줄·색 없이 실명만. 인쇄에 밑줄이 새지 않는다.
 * - 렌더 DOM은 `button[data-hospital-alias][data-hospital-link="true"]` — 편집 진입 DOM 추출이
 *   이 속성으로 버튼을 찾아 span으로 바꿔 alias를 보존한다(편집 왕복 규약, 유지).
 * - `label`(진료과·종별)은 계약 prop이나 표시엔 쓰지 않는다. 파생 소비자 방어를 위해 optional.
 * - "선택됨" 시각 표시는 본문에 두지 않는다(spec 설계 결정 13). 선택 상태는 좌측 처방 패널에만 남는다.
 */
export interface HospitalButtonProps {
  alias: string;
  name: string;
  label?: string;
  onHospitalClick?: (alias: string) => void;
}

const HospitalButton: React.FC<HospitalButtonProps> = ({
  alias,
  name,
  label,
  onHospitalClick,
}) => {
  // 핸들러가 없으면(인쇄·임베드 평문 경로) 버튼이 아닌 평문 span — 밑줄·색 없음.
  if (!onHospitalClick) {
    return (
      <span data-hospital-alias={alias} data-hospital-link="true" title={name}>
        {name}
      </span>
    );
  }

  return (
    <InlineMarkerButton
      type="button"
      onClick={() => onHospitalClick(alias)}
      data-hospital-alias={alias}
      data-hospital-link="true"
      title={name}
    >
      {name}
    </InlineMarkerButton>
  );
};

export default HospitalButton;
